module.exports = __webpack_public_path__ + "img/car.37141392.png";